window.Grape.registry.addRegister('FormulaFunctions');

window.Grape.registry.addItem('FormulaFunctions', 'and', (...args) => {
	if (args.length === 0) return true;
	return args.every(arg => Boolean(arg));
});

window.Grape.registry.addItem('FormulaFunctions', 'or', (...args) => {
	if (args.length === 0) return false;
	return args.some(arg => Boolean(arg));
});

window.Grape.registry.addItem('FormulaFunctions', 'sum', (...args) => {
	if (args.length === 0) return 0;
	return args.reduce((acc, val) => acc + (Number(val) || 0), 0);
});

window.Grape.registry.addItem('FormulaFunctions', 'multiply', (...args) => {
	if (args.length === 0) return 0;
	return args.reduce((acc, val) => acc * (Number(val) || 0), 1);
});

window.Grape.registry.addItem('FormulaFunctions', 'divide', (a, b) => {
	if (b === 0) throw new Error('Division by zero');
	return Number(a) / Number(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'subtract', (a, b) => {
	return Number(a) - Number(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'equal', (a, b) => {
	return a === b;
});

window.Grape.registry.addItem('FormulaFunctions', 'stringEqual', (a, b) => {
	return String(a) === String(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'dateEqual', (a, b) => {
	return new Date(a).getTime() === new Date(b).getTime();
});

window.Grape.registry.addItem('FormulaFunctions', 'timeEqual', (a, b) => {
	return String(a) === String(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'timeGreaterThanOrEqual', (a, b) => {
	return String(a) >= String(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'timeLessThanOrEqual', (a, b) => {
	return String(a) <= String(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'arrayContains', (arr, value) => {
	return Array.isArray(arr) && arr.includes(value);
});

window.Grape.registry.addItem('FormulaFunctions', 'stringArray', (arr) => {
	return Array.isArray(arr) && arr.every(item => typeof item === 'string');
});

window.Grape.registry.addItem('FormulaFunctions', 'stringAtLeastOneMemberOf', (str, arr) => {
	return Array.isArray(arr) && arr.includes(String(str));
});

window.Grape.registry.addItem('FormulaFunctions', 'if', (condition, trueValue, falseValue) => {
	return Boolean(condition) ? trueValue : falseValue;
});

window.Grape.registry.addItem('FormulaFunctions', 'ifNot', (condition, falseValue, trueValue) => {
	return Boolean(condition) ? trueValue : falseValue;
});

window.Grape.registry.addItem('FormulaFunctions', 'lessThan', (a, b) => {
	return Number(a) < Number(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'greaterThan', (a, b) => {
	return Number(a) > Number(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'lessThanOrEqual', (a, b) => {
	return Number(a) <= Number(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'greaterThanOrEqual', (a, b) => {
	return Number(a) >= Number(b);
});

window.Grape.registry.addItem('FormulaFunctions', 'value', (a) => {
	return a;
});